import { defineMessages } from 'react-intl';

export const msgs = defineMessages({
  ariaLabel: {
    id: `memrise_logo_link_alt_text`,
  },
});
